import * as React from 'react'
import { Link } from '@amzn/dvui/dist/Link'
import { Badge, badges } from '@amzn/dvui/dist/Badge'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { TextLocalizer } from '../localizer/localizer'
import { StringId } from '../localizer/stringId'
import { roundValue } from '../../utils/numberUtils'
import { withLocalization, LocalizerProps } from '../localizer/localizer'
import { safeBoolean } from '../../utils/utils'

export interface IAmazonRatingBadgeProps {
  amazonRating?: WpsRuntime.atv.wps.AmazonRatingProps,
  pageTitleId: string
  isRetail: boolean
  offerAvailableOn?: string
  showFirstReviewLink?: boolean,
  isCerberusChild: boolean
}

type LocalizedAmazonRatingProps = IAmazonRatingBadgeProps & LocalizerProps

const reviewsAllowed = (offerAvailableDate: string) => Date.now() > new Date(offerAvailableDate).getTime()

const reviewLink = '/review/create-review/ref=acr_dpinstantvideo_solicit?ie=UTF8&asin='



interface FirstReviewProps {
  titleId: string,
  offerAvailableOn?: string
}
const BeTheFirstToReview = ({ titleId, offerAvailableOn }: FirstReviewProps) => {
  if (offerAvailableOn && !reviewsAllowed(offerAvailableOn)) {
    return null
  }

  return <Link href={`${reviewLink}${titleId}`}>
    <TextLocalizer stringID={StringId.DV_DP_first_review} />
  </Link>
}

const ratingClass = (formattedValue: number) => {
  const ratingNumbers = `${formattedValue}`.split('.')
  return ['av-stars', ...ratingNumbers].join('-')
}

const AmazonRatingWithLocalization = ({
                                        amazonRating,
                                        pageTitleId,
                                        isRetail,
                                        offerAvailableOn,
                                        showFirstReviewLink = true,
                                        getString,
                                        isCerberusChild
}: LocalizedAmazonRatingProps) => {
  // We don't show Amazon Rating on Fogg
  if (!isRetail || global.__NATIVEAPP__) {
    return null
  }
  const value = amazonRating && amazonRating.value
  const count = amazonRating && amazonRating.count
  const countFormatted = amazonRating && amazonRating.countFormatted

  if (!count || !value) {
    if (showFirstReviewLink && !safeBoolean(isCerberusChild)) {
      return <BeTheFirstToReview titleId={pageTitleId} offerAvailableOn={offerAvailableOn} />
    }
    return null
  }

  const ariaLabel = getString(StringId.DV_DP_ARIA_amazon_rating, { ratingValue: roundValue(value, 10).toString(), customerCount: count.toString() })

  const rating =
    <>
      <span className={`av-icon av-icon--amazon_rating ${ratingClass(roundValue(value, 2))}`} />
      <span>({countFormatted})</span>
    </>

  const badgeContent = safeBoolean(isCerberusChild) ? rating :
    <a href="#customer-review-section" aria-label={ariaLabel}>
      {rating}
    </a>

  return (<Badge use={badges.TEXT}>
    {badgeContent}
  </Badge>)
}

export const AmazonRating = withLocalization(AmazonRatingWithLocalization)
